var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('input',{ref:"input",attrs:{"type":"file","id":"uploader"},on:{"change":_vm.handleFiles}}),_c('label',{staticClass:"avatar-btn-add",attrs:{"for":"uploader"}}),_c('div',[_vm._v(" "+_vm._s(_vm.imgSrc)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }